import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const c = t((r, e) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: e,
    ...r,
    image: (s) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...s,
        children: /* @__PURE__ */ o.jsx("circle", { cx: 16, cy: 16, r: 3, stroke: "currentColor", strokeWidth: 2 })
      }
    )
  }
));
c.displayName = "Acne1Icon";
export {
  c as Acne1Icon,
  c as default
};
//# sourceMappingURL=index.js.map
